const FreqColumns = () => {
  return [
    {
      title: 'Frequency',
      dataIndex: 'name',
    },
    {
      title: 'Rank',
      dataIndex: 'rank',
      editable: true,
      width: '50%',
    },
  ];
};

export default FreqColumns;
